import { render } from "./ModalMerch.vue?vue&type=template&id=3f6ca6f0"
import script from "./ModalMerch.vue?vue&type=script&lang=js"
export * from "./ModalMerch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__